/**
 * Year Selector
 * Option to select which years you want included in the demographic bar chart
 * https://targetsmart.atlassian.net/browse/SE-794
 */

import React, { useContext } from "react";
import Select from "react-select";
import { ArrayParam, useQueryParams, withDefault } from "use-query-params";
import { ConfigContext } from "../ConfigContext";

export default function YearSelector({ selectableYears }) {
  let config = useContext(ConfigContext);
  let [queryParams, setQueryParams] = useQueryParams({
    comparison_years: withDefault(ArrayParam, [...selectableYears]),
  });
  let { comparison_years } = queryParams;
  let colorMappings = {};
  config.YEAR_LABELS.forEach((year_key, i) => {
    colorMappings[year_key] = config.YEAR_COLORS[i];
  });
  return (
    <fieldset className={"d-flex"}>
      <legend>Years for Comparison</legend>
      <Select
        isMulti
        styles={{
          multiValue: (styles, props) => {
            return {
              ...styles,
              borderLeft: `3px solid ${colorMappings[props.data.value]}`,
            };
          },
        }}
        classNames={{
          control: () => "border-0 rounded-0 mb-3",
          multiValue: () => {
            return "rounded-0";
          },
        }}
        options={[...selectableYears].reverse().map((opt) => {
          return { value: opt, label: opt };
        })}
        onChange={(years) => {
          setQueryParams({ comparison_years: years.map((obj) => obj.value) });
        }}
        defaultValue={comparison_years.map((opt) => {
          return { value: opt, label: opt };
        })}
      ></Select>
    </fieldset>
  );
}
